import React from "react";
// import { PagesLayout } from "../../layout";
import Layout from "../../layout/PagesLayout/Layout";
import Home from "./Home";
import AddServices from "./AddServices";
import { useLocation } from "react-router-dom";

const Index = () => {
  const location = useLocation();
  const isAddServicesPage = location.pathname === "/add-services";
  
  return (
    <>
      <Layout children={isAddServicesPage ? <AddServices /> : <Home />} />
    </>
  );
};

export default Index;
